import React from "react";
import { Search } from "lucide-react";

const JOB_TYPES = ["Full-time", "Part-time", "Contract", "Internship"];
const EXPERIENCE_LEVELS = ["Entry", "Mid", "Senior", "Lead"];

export default function JobFilters({ filters, setFilters }) {
  const update = (key, value) => setFilters((f) => ({ ...f, [key]: value }));

  return (
    <div className="glass-panel rounded-xl p-4 mb-6 space-y-3" data-testid="job-filters-panel">
      <div className="relative">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          value={filters.q} onChange={(e) => update("q", e.target.value)}
          placeholder="Search by title, company, or keyword..." data-testid="job-search-input"
          className="w-full bg-white/5 border border-white/10 rounded-lg pl-9 pr-3 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-indigo-400"
        />
      </div>
      <div className="flex flex-wrap gap-2">
        <input
          value={filters.location} onChange={(e) => update("location", e.target.value)}
          placeholder="Location" data-testid="job-location-filter-input"
          className="flex-1 min-w-[140px] bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-xs text-white placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-indigo-400"
        />
        <select
          value={filters.job_type} onChange={(e) => update("job_type", e.target.value)} data-testid="job-type-filter-select"
          className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-xs text-slate-200"
        >
          <option value="">All Job Types</option>
          {JOB_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
        <select
          value={filters.experience_level} onChange={(e) => update("experience_level", e.target.value)} data-testid="job-experience-filter-select"
          className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-xs text-slate-200"
        >
          <option value="">All Experience Levels</option>
          {EXPERIENCE_LEVELS.map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
      </div>
    </div>
  );
}
